import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isSome as e } from "../../core/maybe.js";
import { addFrameTask as t } from "../../core/scheduling.js";

var a = /*#__PURE__*/function () {
  function a(t) {
    var _this = this;

    _classCallCheck(this, a);

    this.view = t, this._frameTaskHandle = null, this._updateRequested = !1, this.stationary = !0, this.updateEnabled = !0, this.animationInProgress = !1, this.prepare = function () {
      _this._updateParameters.state = _this.view.state, _this._updateParameters.stationary = _this.view.stationary, _this._updateParameters.pixelRatio = window.devicePixelRatio, _this._updateParameters.renderingOptions = _this.view.renderingOptions;
    }, this.update = function () {
      if (_this._updateRequested = !1, !_this.updateEnabled) return;
      var _this$view = _this.view,
          t = _this$view.basemapView,
          _a = _this$view.graphicsView,
          s = _this$view.labelManager,
          i = _this$view.layerViews,
          r = _this$view.state.id;
      t.baseLayerViews.forEach(_this._updateLayerView, _this), i.forEach(_this._updateLayerView, _this), t.referenceLayerViews.forEach(_this._updateLayerView, _this), e(s) && (s.lastUpdateId !== r && (s.viewChange(), s.lastUpdateId = r), s.updateRequested && s.processUpdate(_this._updateParameters)), e(_a) && (_a.lastUpdateId !== r && (_a.viewChange(), _a.lastUpdateId = r), _a.updateRequested && _a.processUpdate(_this._updateParameters)), _this.view.graphicsTileStore.setViewState(_this._updateParameters.state), _this.animationInProgress || _this._updateRequested || _this._frameTaskHandle.pause();
    };
  }

  _createClass(a, [{
    key: "destroy",
    value: function destroy() {
      this.stop();
    }
  }, {
    key: "start",
    value: function start() {
      var _this2 = this;

      this.stationary = this.view.stationary, this._updateParameters = {
        state: this.view.state,
        pixelRatio: window.devicePixelRatio,
        stationary: this.stationary,
        renderingOptions: this.view.renderingOptions
      }, this._stationaryHandle = this.view.watch("stationary", function (e) {
        _this2.stationary = e, _this2.requestFrame();
      }), this._frameTaskHandle = t(this);
    }
  }, {
    key: "stop",
    value: function stop() {
      this._frameTaskHandle && (this._stationaryHandle.remove(), this._frameTaskHandle.remove(), this._updateParameters = this._stationaryHandle = this._frameTaskHandle = null, this.stationary = !0, this.animationInProgress = !1);
    }
  }, {
    key: "requestUpdate",
    value: function requestUpdate() {
      this._updateRequested || (this._updateRequested = !0, this.requestFrame());
    }
  }, {
    key: "requestFrame",
    value: function requestFrame() {
      this._frameTaskHandle && this._frameTaskHandle.resume();
    }
  }, {
    key: "_updateLayerView",
    value: function _updateLayerView(e) {
      var t = this.view.state,
          _a2 = e.lastUpdateId;
      null != _a2 && (this.stationary || e.moving) || (e.moving = !0, e.moveStart()), _a2 !== t.id && e.viewChange(), this.stationary && e.moving && (e.moving = !1, e.moveEnd()), e.lastUpdateId = t.id, e.updateRequested && e.processUpdate(this._updateParameters), "layerViews" in e && e.layerViews.forEach(this._updateLayerView, this);
    }
  }]);

  return a;
}();

export { a as default };